import {Customer} from "./customer";

export class Payment {
  id: string;
  amount: number;
  invoiceId: number;
  sessionId: number;
}



// WEBPACK FOOTER //
// ./src/app/payment.ts